export const Props = () => ({
  //Ссылка на картинку
  image: { type: String },

  //Имя монеты
  name: { type: String },

  //Тикер
  ticker: { type: String },

  //Ссылка на ресурс
  link: { type: String },
});